import React from "react";

import Typography from "@mui/joy/Typography";
import Pagination from "../Pagination/Pagination";
import {Checkbox, Stack, Table} from "@mui/joy";
import Link from "@mui/joy/Link";
import Chip from "@mui/joy/Chip";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";

// components
import withNavigate from "../../utils/withNavigate";
import CommonFilterModal from "./CommonFilterModal";
import CommonFilterSidebar from "./CommonFilterSidebar";
import {generatePath} from "react-router-dom";
import {deleteArrayItemByKeyValue, findArrayItemsByKeyValue, getNestedField} from "../../utils/misc";
import CommonEditModal from "./CommonEditModal";
import {joyTheme} from "../../theme";
import CommonCopyToClipboard from "./CommonCopyToClipboard";
import TotalCard from "../Financial/TotalCard";
import CommonCallBackButton from "./CommonCallBackButton";

// icons
import DownloadIcon from '@mui/icons-material/Download';
import Card from "@mui/joy/Card";
import Divider from "@mui/joy/Divider";



class CommonPaginatedTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uuid: crypto.randomUUID(),
            selected: new Set(),
            sorting: [],
        };
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            this.retrieveUUID();
        }
    }

    retrieveUUID(){
        this.setState({
            uuid: crypto.randomUUID()
        })
    }

    changeSelected(event){
        let id = parseInt(event.target.name.split('-')[1])
        if (event.target.checked) {
            this.addSelected(id)
        } else {
            this.removeSelected(id)
        }
    }

    addSelected(id){
        let selected = this.state.selected;
        selected.add(id);
        this.setState({
            selected: selected
        })
    }

    removeSelected(id){
        let selected = this.state.selected
        selected.delete(id)
        this.setState({
            selected: selected
        })
    }

    render() {
        let sortedData = this.props.data;
        for (let field of this.state.sorting){
            if (this.props.data.length){
                let f
                switch (typeof this.props.data[0][field.key]){
                    case 'string':
                        f = (a, b) => {
                            const nameA = a[field.key].toUpperCase();
                            const nameB = b[field.key].toUpperCase();
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            return 0;
                        }
                        break;
                    case 'number':
                        f = (a, b) => a[field.key] - b[field.key]
                        break;
                    default:
                        f = (a, b) => 0
                }
                sortedData.sort(f)
                if (field.value === 'd'){
                    sortedData.reverse()
                }
            }
        }

        let fieldCount = this.props.fields.filter((e) => e.visible).length


        return (
            <Stack
                spacing={2}
            >
                <Stack
                    key={'CommonPaginatedTable' + this.state.uuid}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                    sx={{
                        mb: this.props.extraComponents || this.props.title || this.props.selection || this.props.download || this.props.filterFields?2:0
                    }}
                >

                    {
                        this.props.title?
                            <Typography
                                level="h4"
                            >
                                {this.props.title}
                            </Typography>:
                            null
                    }
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        {
                                this.props.selection?.buttons?
                                    <>
                                        {
                                            this.props.selection?.buttons.filter((b)=>(b.position==='top')).map((b)=>(
                                                <CommonCallBackButton
                                                    {...b}
                                                    callBack={()=>{b.callBack([...this.state.selected])}}
                                                />
                                            ))
                                        }
                                    </>
                                    :null
                        }
                        {
                            this.props.download?
                                <Box
                                    sx={{
                                        display: 'inline'
                                    }}
                                >
                                    <Button
                                        sx={{mt: 1, mb: 1, mr: 1}}
                                        size={'sm'}
                                        startDecorator={<DownloadIcon fontSize={'small'}/>}
                                        onClick={() => (this.props.download.callBack())}
                                        variant={'soft'}
                                    >
                                        Скачать
                                    </Button>
                                </Box>:
                                null
                        }
                        {
                            this.props.extraComponents?
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    useFlexGap
                                    sx={{
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    {
                                        this.props.extraComponents.filter(c => !c.hidden).map((c)=>(
                                            <c.component
                                                {...c.componentProps}
                                                callBack={c.callBack?c.callBack:this.props.callBack}
                                            />
                                        ))
                                    }
                                </Stack>
                                :null
                        }
                        {
                            this.props.filterFields?
                                <CommonFilterModal
                                    key={'CommonFilterModal'+crypto.randomUUID()}
                                    callBack={this.props.filterCallBack}
                                    fields={this.props.filterFields}
                                    value={this.props.filterValue}
                                />:
                                null
                        }
                    </Stack>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={2}
                >
                    {
                        this.props.filterSidebar?
                            <CommonFilterSidebar
                                {...this.props.filterSidebar}
                            />:
                            null
                    }
                    <Stack
                        spacing={1}
                        sx={{
                            width: '100%'
                        }}
                    >
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                width: '100%',
                                justifyContent: 'space-between',
                                display: {
                                    xs: 'none',
                                    sm: 'none',
                                    md: 'flex',
                                    lg: 'flex',
                                }
                            }}
                        >
                            {this.props.fields.map((field) => {
                                if (!field.visible){
                                    return null
                                }
                                return (
                                    <Box
                                        key={'header-'+field.name}
                                        sx={{
                                            width: field.width?field.width:(100/fieldCount).toString() + '%',
                                            flexGrow: 2,
                                            height: '1.5rem'
                                        }}
                                        size={'sm'}
                                        variant={'soft'}
                                    >
                                        <Stack
                                            direction={'row'}
                                            spacing={1}
                                            sx={{
                                                width: '100%',
                                                maxHeight: '100%'
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    fontSize: '0.8rem',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {field.title}
                                            </Box>
                                            {
                                                this.props.sortingFields?.includes(field.name)?
                                                    <Stack
                                                        direction={'row'}
                                                        spacing={1}
                                                    >

                                                        <span
                                                            onClick={
                                                                () => {
                                                                    let sorting = this.state.sorting;
                                                                    let sorter = findArrayItemsByKeyValue(sorting, 'key', field.name)
                                                                    let value = 'a'
                                                                    if (sorter.length){
                                                                        if (sorter[0].value === 'a'){
                                                                            value = 'd'
                                                                        }
                                                                    }
                                                                    sorting = deleteArrayItemByKeyValue(
                                                                        sorting,
                                                                        'key',
                                                                        field.name
                                                                    );
                                                                    sorting.push(
                                                                        {
                                                                            key: field.name,
                                                                            value: value
                                                                        }
                                                                    )
                                                                    this.setState({
                                                                        sorting: sorting,
                                                                    })
                                                                }
                                                            }
                                                            style={{
                                                                color: this.state.sorting.map((s) => s.key).indexOf(field.name) === -1?'grey':'lightblue',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            ⥮
                                                        </span>
                                                        {
                                                            this.state.sorting.map((s) => s.key).indexOf(field.name) !== -1?
                                                                <>[{this.state.sorting.map((s) => s.key).reverse().indexOf(field.name) + 1}]</>:
                                                                null
                                                        }
                                                        <span
                                                            style={{
                                                                color: 'red',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={
                                                                () => {
                                                                    let sorting = this.state.sorting;
                                                                    sorting = deleteArrayItemByKeyValue(
                                                                        sorting,
                                                                        'key',
                                                                        field.name
                                                                    );
                                                                    this.setState({
                                                                        sorting: sorting,
                                                                    })
                                                                }
                                                            }
                                                        >
                                                            ⤫
                                                        </span>
                                                    </Stack>
                                                    :
                                                    null
                                            }
                                        </Stack>

                                    </Box>
                                )
                            })}
                            {
                                this.props.selection?
                                    <th key={'header-selection'}>

                                    </th>:
                                    null
                            }
                        </Stack>
                        <Divider
                            sx={{
                                height: '2px'
                            }}
                        />
                        <Stack
                            spacing={1}
                            sx={{
                                width: '100%',
                            }}
                        >
                            {sortedData.map((each) => {
                                let rowColorKey = this.props.color?this.props.color.rule(
                                    this.props.color.value?getNestedField(each, this.props.color.value, false):null,
                                    this.props.color.comparison?getNestedField(each, this.props.color.comparison, false):null,
                                ):null;
                                return (
                                    <>
                                        <Card
                                            key={this.props.url+'-'+each.id}
                                            style={{
                                                backgroundColor: joyTheme.colorSchemes[localStorage.getItem("joy-mode")].palette[rowColorKey]?.softBg,
                                                color: joyTheme.colorSchemes[localStorage.getItem("joy-mode")].palette[rowColorKey]?.mainChannel,
                                            }}
                                            size={'sm'}
                                            sx={{
                                                width: '100%',
                                                justifyContent: {
                                                    xs: null,
                                                    sm: null,
                                                    md: 'space-between',
                                                    lg: 'space-between',
                                                },
                                                p: 0,
                                                position: 'relative',
                                            }}
                                            variant={'plain'}
                                        >
                                            <Stack
                                                direction={'row'}
                                                useFlexGap
                                                spacing={1}
                                                sx={{
                                                    flexWrap: {
                                                        xs: 'wrap',
                                                        sm: 'wrap',
                                                        md: 'nowrap',
                                                        lg: 'nowrap',
                                                    },
                                                    position: 'relative',
                                                    alignItems: 'center',
                                                }}
                                                // style={{
                                                //     backgroundColor: joyTheme.colorSchemes[localStorage.getItem("joy-mode")].palette[rowColorKey]?.softBg,
                                                //     color: joyTheme.colorSchemes[localStorage.getItem("joy-mode")].palette[rowColorKey]?.mainChannel,
                                                // }}
                                            >
                                                {this.props.fields.map((field) => {

                                                let rowHidden = field.rowHidden ? field.rowHidden.rule(
                                                    field.rowHidden.value ? getNestedField(each, field.rowHidden.value, false) : null,
                                                    field.rowHidden.comparison ? getNestedField(each, field.rowHidden.comparison, false) : null,
                                                ) : false
                                                if (!field.visible){
                                                    return null
                                                }
                                                if (rowHidden){
                                                    return (
                                                        <Box
                                                        key={this.props.url+'-'+each.id+'-'+field.name}
                                                        sx={{
                                                            width: {
                                                                xs: '50%',
                                                                sm: '33.33%',
                                                                md: field.width?field.width:(100/fieldCount).toString() + '%',
                                                                lg: field.width?field.width:(100/fieldCount).toString() + '%',
                                                            },
                                                            minWidth: {
                                                                xs: '50%',
                                                                sm: '33.33%',
                                                                md: null,
                                                                lg: null,
                                                            },
                                                            m: 0,
                                                            flexGrow: 2,
                                                            fontSize: '0.8rem',
                                                            position: field.position?field.position:'relative',
                                                        }}
                                                        ></Box>
                                                    )
                                                }
                                                return (
                                                    <Box
                                                        key={this.props.url+'-'+each.id+'-'+field.name}
                                                        sx={{
                                                            width: {
                                                                xs: '50%',
                                                                sm: '33.33%',
                                                                md: field.width?field.width:(100/fieldCount).toString() + '%',
                                                                lg: field.width?field.width:(100/fieldCount).toString() + '%',
                                                            },
                                                            minWidth: {
                                                                xs: '50%',
                                                                sm: '33.33%',
                                                                md: null,
                                                                lg: null,
                                                            },
                                                            m: 0,
                                                            flexGrow: 2,
                                                            fontSize: '0.8rem',
                                                            position: field.position?field.position:'relative',
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                fontSize: '0.6rem',
                                                                fontWeight: 600,
                                                                width: '100%',
                                                                display: {
                                                                    xs: 'flex',
                                                                    sm: 'flex',
                                                                    md: 'none',
                                                                    lg: 'none',
                                                                }
                                                            }}
                                                        >
                                                            {field.title}
                                                        </Box>
                                                        <Stack
                                                            direction={'row'}
                                                            spacing={1}
                                                            alignItems={'center'}
                                                            sx={{
                                                                width: '100%',
                                                            }}
                                                        >
                                                            <Stack
                                                                direction={'row'}
                                                                sx={{
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {
                                                                    field.copy?
                                                                        <CommonCopyToClipboard
                                                                            content={(() => {
                                                                                if (Array.isArray(field.name)){
                                                                                    return field.name.map((n) => (
                                                                                        getNestedField(each, n, false, field.preProcess)
                                                                                    )).join(" ")
                                                                                }
                                                                                return getNestedField(each, field.name, false, field.preProcess)
                                                                            })()}
                                                                        />:
                                                                        null
                                                                }
                                                                {
                                                                    field.linkPattern?
                                                                        <Box
                                                                            sx={{
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            <Link
                                                                                fontSize={'0.8rem'}
                                                                                href={
                                                                                    (() =>{
                                                                                        let linkParam = getNestedField(each, field.linkParam, false, null, true)
                                                                                        if (linkParam){
                                                                                            return generatePath(
                                                                                                field.linkPattern,
                                                                                                {
                                                                                                    linkParam: linkParam
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                        else {
                                                                                            return null
                                                                                        }
                                                                                    })()
                                                                                }
                                                                                target={field.linkTarget}
                                                                                sx={{
                                                                                    width: '100%',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    Array.isArray(field.name)?
                                                                                        <Stack
                                                                                            direction={'row'}
                                                                                            spacing={1}
                                                                                            useFlexGap
                                                                                            sx={{ flexWrap: 'wrap' }}
                                                                                        >
                                                                                            {
                                                                                                field.name.map((n) => (
                                                                                                    <>{getNestedField(each, n, false, field.preProcess)} </>
                                                                                                ))
                                                                                            }
                                                                                        </Stack>:
                                                                                        <>{getNestedField(each, field.name, false, field.preProcess)} </>
                                                                                }
                                                                            </Link>
                                                                        </Box>
                                                                    : field.component ?
                                                                        <field.component
                                                                            componentId={each.id}
                                                                            componentObj={each}
                                                                            callBack={field.callBack}
                                                                            url={this.props.url}
                                                                            {...field.componentProps}
                                                                        />
                                                                    :
                                                                        <>
                                                                            {
                                                                                field.chip?
                                                                                    <Chip
                                                                                        sx={{
                                                                                            width: '100%',
                                                                                        }}
                                                                                        color={
                                                                                            field.color_rule(
                                                                                                field.color_value?getNestedField(each, field.color_value, false):null,
                                                                                                field.color_comparison?getNestedField(each, field.color_comparison, false):null,
                                                                                            )
                                                                                        }
                                                                                        size={'sm'}
                                                                                    >
                                                                                        {
                                                                                            Array.isArray(field.name)?
                                                                                                <Stack
                                                                                                    direction={'row'}
                                                                                                    spacing={1}
                                                                                                    useFlexGap
                                                                                                    sx={{ flexWrap: 'wrap' }}
                                                                                                >
                                                                                                    {
                                                                                                        field.name.map((n) => (
                                                                                                            <>{getNestedField(each, n, false, field.preProcess)} </>
                                                                                                        ))
                                                                                                    }
                                                                                                </Stack>:
                                                                                                <>{getNestedField(each, field.name, true, field.preProcess)} </>
                                                                                        }
                                                                                    </Chip>:
                                                                                    <>
                                                                                        {
                                                                                            Array.isArray(field.name)?
                                                                                                <Stack
                                                                                                    direction={'row'}
                                                                                                    spacing={1}
                                                                                                    useFlexGap
                                                                                                    sx={{ flexWrap: 'wrap' }}
                                                                                                >
                                                                                                    {
                                                                                                        field.name.map((n) => (
                                                                                                            <>{getNestedField(each, n, false, field.preProcess)} </>
                                                                                                        ))
                                                                                                    }
                                                                                                </Stack>:
                                                                                                <>{getNestedField(each, field.name, true, field.preProcess)} </>
                                                                                        }
                                                                                    </>
                                                                            }
                                                                        </>
                                                                }
                                                            </Stack>
                                                            {
                                                                field.edit && field.edit.permission?
                                                                    <CommonEditModal
                                                                        overlay={true}
                                                                        fields={field.edit.fields}
                                                                        m2mFields={field.edit.m2mFields}
                                                                        baseUrl={field.edit.baseUrl}
                                                                        obj={
                                                                            (() => {
                                                                                if (field.edit.obj){
                                                                                    let obj = {}
                                                                                    for (let key of Object.keys(field.edit.obj)){
                                                                                        obj[key] = getNestedField(each, field.edit.obj[key],false)
                                                                                    }
                                                                                    return obj
                                                                                }
                                                                                return each
                                                                            })()
                                                                        }
                                                                        callBack={field.edit.callBack || this.props.callBack}
                                                                        buttonIconOnly={true}
                                                                    />
                                                                    :
                                                                    null
                                                            }
                                                        </Stack>
                                                    </Box>
                                                )
                                            })}
                                                {
                                                    this.props.selection?
                                                        <Box
                                                            key={'Selection' + each.id}
                                                        >
                                                            <Checkbox
                                                                name={'checkbox-'+each.id}
                                                                defaultChecked={this.state.selected.has(each.id)}
                                                                onChange={this.changeSelected.bind(this)}
                                                            />
                                                        </Box>:
                                                        null
                                                }
                                            </Stack>

                                        </Card>
                                        <Divider />
                                    </>
                                )
                            })}
                        </Stack>
                        {
                            this.props.data?.length === 0?
                                <Chip
                                    color={'warning'}
                                    sx={{mt: 1}}
                                    size={'sm'}
                                >
                                    Список пуст
                                </Chip>:
                                null
                        }
                    </Stack>
                </Stack>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        width: '100%'
                    }}
                >
                    {
                            this.props.selection?.buttons?
                                <>
                                    {
                                        this.props.selection?.buttons.filter((b)=>(b.position==='bottom')).map((b)=>(
                                            <CommonCallBackButton
                                                {...b}
                                                callBack={()=>{b.callBack([...this.state.selected])}}
                                            />
                                        ))
                                    }
                                </>
                                :null
                    }
                </Stack>
                {
                    this.props.pages?
                       <Pagination
                            count={this.props.pages}
                            page={this.props.pageNumber}
                            onClick={
                                (value) => {
                                    if (typeof this.props.pagesCallback == 'function') {
                                        this.props.pagesCallback(value);
                                    }
                                    if (this.props.url) {
                                        this.props.navigate(`/${this.props.url}/page/`+value);
                                    }
                                }
                            }
                            key={'PaginationPage' + this.props.pageNumber}
                        />:
                        null
                }
                {
                    this.props.summary?
                        <Stack>
                            <Typography
                                level={'body-lg'}
                                sx={{
                                    mb: 2
                                }}
                            >
                                Итоги
                            </Typography>
                            <Stack
                                direction={'row'}
                                spacing={2}
                                useFlexGap
                                sx={{
                                    flexWrap: 'wrap'
                                }}
                            >
                                {
                                    this.props.summary.map((field) => {
                                        if (!field.visible){
                                            return <></>
                                        }
                                        let value = 0;
                                        if (Array.isArray(field.name)){
                                            for (const name of field.name){
                                                value += this.props.data.reduce(
                                                    (accumulator, row) => accumulator + getNestedField(row, name, false, field.preProcess), 0
                                                )
                                            }
                                        }
                                        else {
                                            value = this.props.data.reduce(
                                                (accumulator, row) => accumulator + getNestedField(row, field.name, false, field.preProcess), 0
                                            )
                                        }
                                        return (
                                            <TotalCard
                                                title={field.title}
                                                color={field.color}
                                                value={value}
                                                numberFormat={field.numberFormat?field.numberFormat:Intl.NumberFormat('ru', {maximumFractionDigits: 2})}
                                            />
                                        )
                                    })
                                }
                            </Stack>
                        </Stack>:
                        null
                }
            </Stack>
        )
    }
}

export default withNavigate(CommonPaginatedTable)